import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AuthGuard } from "../auth/auth-guard.service";
import { EnquiryDetailComponent } from "./enquiry-detail/enquiry-detail.component";
import { EnquiryListComponent } from "./enquiry-list/enquiry-list.component";

const enquiryRoutes: Routes = [
    { path: "enquiries", component: EnquiryListComponent, canActivate: [AuthGuard] },
    { path: "enquiries/new", component: EnquiryDetailComponent, canActivate: [AuthGuard] },
    { path: "enquiries/:id", component: EnquiryDetailComponent, canActivate: [AuthGuard] },
];

@NgModule({
    imports: [RouterModule.forChild(enquiryRoutes)],
    exports: [RouterModule]
})

export class EnquiryRoutingModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/enquiry/enquiry-routing.module.ts